import { ChangeDetectorRef, Component } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { EditGrupoTipoBonoV11Component } from "./edit-grupo-tipo-bono-v11/edit-grupo-tipo-bono-v11.component";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";

@Component({
  selector: "app-grupo-tipo-bono-v11",
  templateUrl: "./grupo-tipo-bono-v11.component.html",
  styleUrls: ["./grupo-tipo-bono-v11.component.scss"],
})
export class GrupoTipoBonoV11Component extends SuperClassComponent {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }

  openPanel() {
    this.customanpanel = EditGrupoTipoBonoV11Component;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
